import UbuyProductCard from '@/components/product/UbuyProductCard';
import type { Product } from '@/data/products';

type CatalogGridProps = {
  products: Product[];
  showBrandBadge?: boolean;
};

export function CatalogGrid({ products }: CatalogGridProps) {
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 xl:grid-cols-4">
      {products.map((product) => (
        <UbuyProductCard key={product.id} product={product} fluid />
      ))}
    </div>
  );
}
